import { useEffect } from "react";
import { distanceToAbsolute, euclid, sample, weightedSample }  from "$utils/math";
import { getPCsFromScaleName, getNextPitchClassAfterPitch, calcDiatonicInterval } from "$utils/music"; // music theory related
import { useSelector } from "react-redux";
import { selectTonality } from "../store";

// maybe shouldnt have to rely on pianorolljs for ids
export const useNoteGenerator = ({ instrument }) => {
    const tonality = useSelector(selectTonality);

    let jsPianoRollEl;
    useEffect(()=> {
        jsPianoRollEl = document.getElementById(instrument.id + "_piano-roll");
    })
    const numSteps =  useSelector(instrument.getDisplayClipLengthSelector());

    const pitchRange = instrument.pitchRange.typical ?? instrument.pitchRange.usable;
    const lowestNote = pitchRange.min;
    const highestNote = pitchRange.max;
    const scalePCs = getPCsFromScaleName(tonality);
    const scalePitchesInRange = new Map();
    let i = 0;
    scalePCs.forEach((scalePC) => {
        const degree = i + 1;
        let octavedPC = getNextPitchClassAfterPitch(scalePC, lowestNote);
        while (octavedPC <= highestNote) {
            scalePitchesInRange.set(octavedPC, {degree: degree});
            octavedPC += 12;
        }
        i++;
    });
    const degreeWeights = {1:5, 2:1, 3:2, 4:1, 5:4, 6:1, 7:1}
    const diatonicIntervalWeights = {0:1, 1:6, 2:1, 3:1, 4:1, 5:1, 7:2}


    const getNextPitch = (previousPitch) => {
        const possiblePitches = [...scalePitchesInRange.keys()];
        const weights = [...scalePitchesInRange.entries()].map(([pitch, noteInfo]) => {
            const degreeWeight = degreeWeights[noteInfo.degree];
            const [intervalQuantity, _] = previousPitch !== undefined ? calcDiatonicInterval(previousPitch, pitch) : [0, 'P'];
            const intervalWeight = diatonicIntervalWeights[Math.abs(intervalQuantity)] ?? 0;
            return degreeWeight * intervalWeight;
        });
        return weightedSample(possiblePitches, weights);
    }

    const randomHalves = (array, iterations=0) => {
        if (typeof array === "number") array = [array];
        if (iterations === 0) return array;

        const newArray = [];
        array.forEach(element=> {
            if (Math.random() < 0.5) {
                newArray.push(element)
            } else {
                newArray.push(element/2, element/2);
            }
        });
        return randomHalves(newArray, iterations - 1);
    }

    const generate = () => {
        
        const parts = randomHalves(numSteps, numSteps/16);
        const durations = [];
        parts.forEach(partDuration=>{
            durations.push(...euclid(sample([2,3,4,5]), partDuration));
        })
        const onsets = distanceToAbsolute(durations).slice(0,-1);
        
        const newSequence = [];
        let previousPitch;
        const firstAvailableID = jsPianoRollEl.getNextAvailableID();
        onsets.forEach((onset, index) => {
            const duration = durations[index];
            const pitch = getNextPitch(previousPitch);
            const nota = {
                onset,
                duration,
                pitch,
                s: 0, // this means not selected
                id: firstAvailableID + index,
            }
            newSequence.push(nota);
            previousPitch = pitch;
        })
        instrument.updateSequence(newSequence);
    }

    return generate;
}